import { useCallback } from "react";

import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

type Props = {
  service: string;
};

const useConprofProfileTypesPoll = ({ service }: Props) => {
  const client = useObservabilityPipelineHttpClient();

  const requestFn = useCallback(async () => {
    if (client === null) return Promise.reject("Null value");
    const response = await client.getContinuousProfilingApps();
    return response.applications[service] ?? null;
  }, [client, service]);

  return usePoller({ timeFrame: null, requestFn });
};

export default useConprofProfileTypesPoll;
